<template>
  <Dialog
    v-model:visible="visibleValue"
    modal
    :draggable="false"
    dismissable-mask
    :pt="{
      header: 'pb-0 justify-end',
      content: 'flex p-0',
    }"
    :style="{
      width: '100%',
      maxWidth: `${breakpointsValues.xl}px`,
    }"
    @hide="onDialogHidden"
  >
    <div class="flex w-full">
      <template v-if="lgAndLarger">
        <DialogSidebar
          v-model:active-tab-name="activeTabName"
          :tabs="tabs"
          class="mb-5 min-h-[50vh] pl-5"
        >
          <template
            v-if="$slots['sidebar-bottom']"
            #bottom
          >
            <slot name="sidebar-bottom" />
          </template>
        </DialogSidebar>

        <div class="w-full overflow-y-auto pb-5 pr-5">
          <component
            :is="activeTabContent?.component"
            v-bind="activeTabContent?.props"
          />
        </div>
      </template>

      <Tabs
        v-else
        :value="tabs[0]?.name"
        class="w-full"
        lazy
      >
        <TabList>
          <Tab
            v-for="tab in tabs"
            :key="tab.name"
            :value="tab.name"
          >
            {{ $te(tab.label) ? $t(tab.label) : tab.label }}
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel
            v-for="tab in tabs"
            :key="tab.name"
            :value="tab.name"
          >
            <component
              :is="tab.component"
              v-bind="tab.props"
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  </Dialog>
</template>

<script lang="ts" setup>
import { breakpointsValues } from '../../../composables/useUI'
import DialogSidebar from './DialogSidebar.vue'

const props = defineProps<{
  visible: boolean
  tabs: {
    label: string
    icon: string
    name: string
    component: any // TODO: Type
    props: { [key: string]: any }
  }[]
}>()
const emits = defineEmits(['hide'])

const visibleValue = computed({
  get: () => props.visible,
  set: () => emits('hide'),
})

const activeTabName = ref(props.tabs[0]?.name)
const activeTabContent = computed(() =>
  props.tabs.find(link => link.name === activeTabName.value),
)

const onDialogHidden = () => {
  activeTabName.value = props.tabs[0]?.name
}
</script>
